const _require = require('@truqc/content-path'),
  getContentValues = _require.getContentValues,
  setValue = _require.setValue,
  getContentValue = _require.getContentValue;
const _require2 = require('ramda'),
  mergeDeepRight = _require2.mergeDeepRight;
const clone = json => JSON.parse(JSON.stringify(json));
const matchesCriteria = (format, criteria) => {
  let result = true;
  Object.keys(criteria).forEach(prop => {
    // handle tags arrays
    if (prop === 'tags') {
      result = (criteria[prop] || []).some(crit => (format[prop] || []).some(form => crit === form));
    } else if (criteria[prop] !== format[prop]) {
      // inequality
      // ignore property being "defined" criteria
      if (!(criteria[prop] === 'isDefined' && format[prop] !== undefined)) {
        result = false;
      }
    }
  });
  return result;
};

/**
 *  Gather paths to the components from the formatInput
 */
const _keyPathsToCriteria = function keyPathsToCriteria(criteriaIn, formatInputIn) {
  let currentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  const criteria = Array.isArray(criteriaIn) ? criteriaIn : [criteriaIn];
  let formatInput = formatInputIn || {};
  if (typeof formatInput === 'string') {
    formatInput = JSON.parse(formatInputIn);
  }
  let keyPaths = [];
  if (criteria.some(criterium => matchesCriteria(formatInput, criterium))) {
    keyPaths.push({
      path: currentPath,
      component: formatInput
    });
  }
  if (Array.isArray(formatInput.children) && formatInput.children.length > 0) {
    formatInput.children.forEach(child => {
      let tmppath = currentPath;
      if (child.contentPath) {
        if (child.contentPath[0] === '/') {
          // start at top of tree
          tmppath = child.contentPath;
        } else {
          tmppath = "".concat(currentPath, "/").concat(child.contentPath);
        }
      }

      // add a wildcard path whenever a collection is found
      if (child.type === 'collection') {
        tmppath += '/*';
      }
      keyPaths = keyPaths.concat(_keyPathsToCriteria(criteria, child, tmppath));
    });
  }
  return keyPaths;
};

/**
 * @function valuesFromPaths - get values from the given components
 * @param {*} keyPaths
 * @param {*} formatInput
 * @param {*} content
 */
const valuesFromPaths = (keyPaths, content) => {
  const result = [];
  keyPaths.forEach(_ref => {
    let path = _ref.path;
    const contentAtPath = getContentValues(path, content);
    if (contentAtPath !== undefined) {
      // null is valid content
      result.push(...contentAtPath); // mutating result
    }
  });
  return result;
};

/**
 * @function valuesFromComponent - get values from the given components
 * @param {*} componentName
 * @param {*} formatInput
 * @param {*} content
 * @param {*} matchingCriteria
 */
const valuesFromComponent = function valuesFromComponent(componentName, formatInput, content) {
  let matchingCriteria = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let criteria = {
    type: componentName
  };
  if (matchingCriteria !== null) {
    criteria = mergeDeepRight(matchesCriteria, criteria);
  }
  const keyPaths = _keyPathsToCriteria(criteria, formatInput);
  return valuesFromPaths(keyPaths, content);
};
const nullPatchFromCriteria = (resultIn, patch, formatInput, criteria) => {
  let result = clone(resultIn);
  const paths = _keyPathsToCriteria(criteria, formatInput) || [];
  if (paths.length > 0) {
    // these are all single picker values.
    // we need to add the _atomic: true to the
    // merge patch
    paths.forEach(pathObject => {
      const path = pathObject.path;
      // IFF there is content in the patch, then set the
      // premerge patch to null.
      const contentAtPath = getContentValue(path, patch);
      if (contentAtPath !== undefined) {
        // check keys and remove `null` since
        // we are rewriting the whole tree.
        // null is valid content
        // mutate `result` !!!
        // eslint-disable-next-line no-param-reassign
        result = setValue(path, result, null);
      }
    });
  }
  return result;
};

/**
 * @function searchContentForKeys Performs a recursive search for a key, returning the values
 * @param {Object} content The content to search for the key in
 * @param {String} key The key to search for
 */
const searchContentForKeys = (content, key) => {
  let result = [];
  if (!content) {
    return result;
  }
  const contentKeys = Object.keys(content);
  const matchFound = contentKeys.some(contentKey => contentKey === key);
  if (matchFound) {
    result.push(content[key]);
  }
  contentKeys.forEach(contentKey => {
    const root = content[contentKey];
    if (typeof root === 'object' && root !== null && Object.keys(root).length > 0) {
      result = result.concat(searchContentForKeys(root, key));
    }
  });
  return result;
};

/**
 * Helper to parse contentPaths into MySQL JSON format
 * e.g. Converts /path/to/content to $.path.to.content
 * @param {String} contentPath - The content path to convert
 */
const contentPathToJsonPath = contentPath => {
  if (typeof contentPath !== 'string' || !contentPath.match(/^\/[^/]*(\/[^/]+)*$/)) {
    throw new Error("Invalid contentPath sent to server (absolute?) ".concat(contentPath));
  }
  if (contentPath === '/') {
    return '$';
  }
  const jsonPath = contentPath.split('/').map(p => {
    if (p.indexOf('-') !== -1) {
      // quote keys with dashes (e.g., UUIDs)
      return "\"".concat(p, "\"");
    }
    return p;
  }).join('.');
  return "$".concat(jsonPath);
};
module.exports = {
  matchesCriteria,
  contentPathToJsonPath,
  keyPathsToCriteria: _keyPathsToCriteria,
  searchContentForKeys,
  nullPatchFromCriteria,
  valuesFromComponent,
  valuesFromPaths
};